import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Logos } from "../../../../Pages/Common/User Management/HelperFunctions";
import { getStoredMode } from "../M_ThemeSelector/M_ThemeSelector.helper";

const ClientLogoComponent = ({ clientName, compact = false }) => {
  const [mode, setMode] = useState(getStoredMode());

  useEffect(() => {
    const handleThemeChange = () => {
      setMode(getStoredMode());
    };

    window.addEventListener("themeChange", handleThemeChange);

    return () => {
      window.removeEventListener("themeChange", handleThemeChange);
    };
  }, []);

  const HTB_LOGO_ONLY =
    "https://stminervaclouddev.blob.core.windows.net/images-store/HTB_LOGO_ONLY.png";

  const getClientLogo = () => {
    if (compact) return HTB_LOGO_ONLY;
    return mode === "dark"
      ? "https://stminervaclouddev.blob.core.windows.net/images-store/htb.png"
      : "https://stminervaclouddev.blob.core.windows.net/images-store/HTBLOGO_Letters_Latest.png";
  };

  const addDefaultSrc = (ev) => {
    ev.target.src = Logos.MINERVA_LOGO;
  };

  const LOGO_HEIGHT = "40px";
  const baseLogoStyle = {
    height: LOGO_HEIGHT,
    minHeight: LOGO_HEIGHT,
    maxHeight: LOGO_HEIGHT,
    width: "auto",
    display: "block",
    margin: "4px auto",
    objectFit: "contain",
    transition: "all 220ms cubic-bezier(0.4, 0, 0.2, 1)",
  };

  const compactStyle = { ...baseLogoStyle, maxWidth: "44px" };

  const fullStyle = { ...baseLogoStyle, maxWidth: "220px" };

  return (
    <img
      style={compact ? compactStyle : fullStyle}
      alt={`${clientName} logo`}
      onError={addDefaultSrc}
      src={getClientLogo()}
    />
  );
};

ClientLogoComponent.propTypes = {
  clientName: PropTypes.string,
  compact: PropTypes.bool,
};

export default React.memo(ClientLogoComponent);
